function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Modal, Loader } from '@reactiveonline/frontend_shared_components';
import Authentication from '../authentication';
export default function AuthorizableLink(_ref) {
  var appProps = _ref.appProps,
    profileData = _ref.profileData,
    linkClass = _ref.linkClass,
    linkContent = _ref.linkContent,
    linkRef = _ref.linkRef,
    authorizableScreen = _ref.authorizableScreen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    authorizationModal = _useState2[0],
    setAuthorizationModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openMenu = _useState6[0],
    setOpenMenu = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    itemHover = _useState8[0],
    setItemHover = _useState8[1];
  function handleAuthorization(e) {
    e.preventDefault();
    if (appProps.user) {
      setOpenMenu(function (prevState) {
        return !prevState;
      });
    } else {
      setAuthorizationModal(true);
    }
  }
  function handleClickedItem(item) {
    if (item.requestType == 'delete') {
      setOpenMenu(false);
      handleLogout();
    } else {
      setOpenMenu(false);
      window.location.href = item.path;
    }
  }
  function handleLogout() {
    setLoading(true);
    var fd = new FormData();
    fd.append('authorized_redirection_url', appProps.redirectAfterAuthPath);
    Rails.ajax({
      type: 'DELETE',
      url: appProps.logoutPath,
      dataType: 'json',
      data: fd,
      success: function success(res) {
        window.location.href = res.redirectUrl || '/';
      },
      error: function error(res) {
        setLoading(false);
      }
    });
  }
  function escFunction(event) {
    if (event.key === "Escape") {
      setOpenMenu(false);
    }
  }
  useEffect(function () {
    document.addEventListener("keydown", escFunction, false);
  }, [openMenu]);
  var overlayStyles = {
    opacity: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  var overlayStylesOpen = {
    zIndex: 9998,
    position: 'fixed',
    transition: 'all 150ms ease-in',
    opacity: 1,
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  var dropDownStyles = {
    zIndex: -999999,
    right: 0,
    top: 0,
    minWidth: 200,
    position: 'absolute',
    transition: 'all 200ms ease-out',
    opacity: 0,
    background: appProps.frontendStyles.headerNavigation.headerBackground
  };
  var dropDownOpenStyles = {
    zIndex: 9999,
    right: 0,
    minWidth: 200,
    position: 'absolute',
    transition: 'all 150ms ease-in',
    transform: 'scale(1)',
    opacity: 1,
    top: '100%',
    background: appProps.frontendStyles.headerNavigation.headerBackground
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: linkClass,
    href: linkRef,
    onClick: handleAuthorization
  }, linkContent), /*#__PURE__*/React.createElement("div", {
    style: openMenu ? overlayStylesOpen : overlayStyles,
    onClick: function onClick() {
      return setOpenMenu(false);
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "menu-options box-shadow ".concat(openMenu ? 'open' : ''),
    style: openMenu ? dropDownOpenStyles : dropDownStyles
  }, profileData && profileData.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      onMouseEnter: function onMouseEnter() {
        return setItemHover(index);
      },
      onMouseLeave: function onMouseLeave() {
        return setItemHover(null);
      },
      onClick: function onClick() {
        return handleClickedItem(item);
      },
      style: _objectSpread({
        padding: 15,
        width: '100%',
        cursor: 'pointer'
      }, itemHover == index ? {
        color: appProps.frontendStyles.headerNavigation.colorHover,
        background: appProps.frontendStyles.headerNavigation.backgroundHover
      } : {
        color: appProps.frontendStyles.headerNavigation.color,
        background: appProps.frontendStyles.headerNavigation.background
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "menu-option-item flex-box items-center",
      style: {
        gap: 10
      }
    }, item.icon && /*#__PURE__*/React.createElement("div", {
      className: "icon flex-box items-center content-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa-light ".concat(item.icon),
      style: {
        fontSize: 12
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "title",
      style: {
        fontSize: 13
      }
    }, item.title)));
  }))), authorizationModal && /*#__PURE__*/React.createElement(Modal, {
    visible: true,
    mode: "medium",
    elementsClass: "",
    closeModal: function closeModal() {
      return setAuthorizationModal(false);
    }
  }, /*#__PURE__*/React.createElement(Authentication, {
    appProps: appProps,
    authorizableRedirectionLink: appProps.redirectAfterAuthPath,
    authorizableRedirectionCompanyLink: appProps.redirectAfterRegisterAsCompanyPath,
    authorizableScreen: authorizableScreen
  })), loading && /*#__PURE__*/React.createElement(Loader, {
    fullPage: true,
    size: "large"
  }));
}